import {IService} from "../../services/IService";
import {BaseEntity, IConstructor} from "../../entities/BaseEntity";

export  class EditModel<T extends BaseEntity> {
    $q:ng.IQService;
    entityId:number;
    entity:T;
    constructor($q:ng.IQService, public service:IService, public ctor:IConstructor<T>){
        this.$q = $q;
    }
    loadEntity(entityId:number):ng.IPromise<boolean>{
        this.entityId = entityId;
        var entityPromise:ng.IPromise<any>;
        if(entityId == null)
            entityPromise = this.$q.when<T>(new this.ctor());
        else
            entityPromise = this.service.get(entityId);
        return entityPromise.then((data)=>{
            this.entity = data;
            return this.$q.when<boolean>(true);
        })
        .catch((exc)=>{
            return this.$q.when<boolean>(true);
        });
    }
    loadData(entityId?:number):ng.IPromise<boolean>{
      return this.loadEntity(entityId);
    }
    verifyData():ng.IPromise<boolean>{
      return this.$q.when<boolean>(true);
    }
    saveData():ng.IPromise<boolean>{
      return this.verifyData().then((ok)=>{
        if(!ok)
          return this.$q.when<boolean>(false);
        var mainPromise:ng.IPromise<any> = null;
        if(this.entityId == null || isNaN(this.entityId))
          mainPromise = this.service.insert(this.entity);
        else
          mainPromise = this.service.update(this.entity);
        return mainPromise.then((data)=> {
          return this.$q.when<boolean>(true);
        })
          .catch((err:any)=>{
            return this.$q.reject("Got error in saving data:"+err);
          });
      });
    }

}
